import { motion } from "framer-motion";
import { imageSrc } from "../../lib/api";

export function GatherBack({ painting, target, onDone }) {
  const W = window.innerWidth, H = window.innerHeight;
  const a = painting.aspect_ratio || 1;
  const h = Math.min(H * 0.7, (W * 0.6) / a);
  const w = h * a;
  const to = target || { x: W / 2, y: H * 0.45 };
  return (
    <motion.div data-testid="gather-back" data-slug={painting.slug} className="pointer-events-none fixed inset-0 z-[65]" initial={{ opacity: 1 }} animate={{ opacity: 1 }}>
      <motion.img
        src={imageSrc(painting.image_url)}
        alt=""
        className="absolute object-cover shadow-[0_0_60px_20px_rgba(255,240,250,0.6)]"
        style={{ width: w, height: h, left: -w / 2, top: -h / 2 }}
        initial={{ x: W / 2, y: H / 2, scale: 1, opacity: 1, borderRadius: "6px" }}
        animate={{ x: to.x, y: to.y, scale: 0.16, opacity: 0, borderRadius: `${w}px ${w}px 12px 12px` }}
        transition={{ duration: 1.15, ease: [0.45, 0, 0.2, 1], opacity: { duration: 1.15, ease: [0.7, 0, 0.9, 0.6] } }}
        onAnimationComplete={onDone}
      />
    </motion.div>
  );
}
